import { render, staticRenderFns } from "./ServiceLayout.vue?vue&type=template&id=095f7ec8&scoped=true&"
import script from "./ServiceLayout.vue?vue&type=script&lang=ts&"
export * from "./ServiceLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceLayout.vue?vue&type=style&index=0&id=095f7ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f7ec8",
  null
  
)

export default component.exports